import {useLocation} from 'react-router-dom'
import useAuth from './useAuth'
import {
  getMaarefatiLandingPath,
  isZadRoute,
  shouldShowBackToMaarefati,
  shouldShowMaarefatiSidebar,
  shouldShowZadLauncher,
  shouldShowZadSidebar,
  resolveWorkspace,
} from '../workspace'

export default function useMaarefatiWorkspace() {
  const {pathname} = useLocation()
  const {me} = useAuth()
  const role = me?.role

  return {
    role,
    pathname,
    workspace: resolveWorkspace(role, pathname),
    isZadRoute: isZadRoute(pathname),
    showZadSidebar: shouldShowZadSidebar(role, pathname),
    showMaarefatiSidebar: shouldShowMaarefatiSidebar(role, pathname),
    showZadLauncher: shouldShowZadLauncher(role, pathname),
    showBackToMaarefati: shouldShowBackToMaarefati(role, pathname),
    maarefatiLandingPath: getMaarefatiLandingPath(role),
  }
}
